export enum PaymentItemType {
  rent = 'rent',
  utilities = 'utilities',
  cleaning = 'cleaning',
  insurance = 'insurance',
  others = 'others'
}
